import script from "./ShowcasesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowcasesTable.vue?vue&type=script&setup=true&lang=js"

import "./ShowcasesTable.vue?vue&type=style&index=0&id=5dd26242&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dd26242"]])

export default __exports__